import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { Gdpr } from "@/components/landing/Gdpr";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <Navbar />
      <Hero />
      <Features />
      <Gdpr />
      <Footer />
    </div>
  );
}
